import { Recipe } from './types'

const FINE_DINE_IN_BRAND_SLUG = 'fine-dine-in'

export const isRecipeFineDineIn = (recipe: Recipe): boolean => {
  return recipe.foodBrand !== null && recipe.foodBrand.slug === FINE_DINE_IN_BRAND_SLUG
}
